import { ChevronRight } from "@tamagui/lucide-icons";
import React, { type PropsWithChildren } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import {
  type GetThemeValueForKey,
  View,
  XStack,
  type XStackProps,
  YStack,
} from "tamagui";
import { Label } from "../../../ui/Label";
import { Subtext } from "../../../ui/Subtext";

export const CreateWizardButton: React.FC<
  PropsWithChildren<
    {
      subText?: string;
      type?: "primary" | "secondary";
    } & XStackProps
  >
> = ({ children, subText, type, ...props }) => {
  let backgroundColor: GetThemeValueForKey<"color">;
  if (type === "secondary") {
    backgroundColor = "$divider";
  } else {
    backgroundColor = props.disabled ? "#ffeba6" : "$primary";
  }

  const { bottom } = useSafeAreaInsets();

  const contentOpacity = props.disabled ? 0.5 : 1;

  return (
    <XStack
      gap="$medium"
      cursor="pointer"
      justifyContent="space-between"
      backgroundColor={backgroundColor}
      alignItems="center"
      paddingHorizontal="$space.large"
      paddingVertical="$space.medium"
      paddingBottom={bottom > 0 ? bottom : "$space.medium"}
      {...props}
    >
      <YStack opacity={contentOpacity} gap="$small" flex={1}>
        <Label>{children}</Label>
        {subText && <Subtext>{subText}</Subtext>}
      </YStack>
      <View opacity={contentOpacity} flexShrink={0}>
        <ChevronRight />
      </View>
    </XStack>
  );
};
